// @ts-check
import factory from "./factory"
import TeaserTemplate from "./TeaserTemplate"
import Image from "@components/Image"
import { Title, Panel, Body } from "./Panel"

const componentDefaults = {
  Template: TeaserTemplate,
  Asset: Image,
}

const panelDefaults = {
  Title: Title,
  Body: Body,
  Wrapper: Panel,
}

/**
 * Teaser that is rendered in a panel-styled manner
 */
export const panelTeaserFactory = ({ displayName, ...props }) =>
  factory({
    ...componentDefaults,
    ...panelDefaults,
    ...props,
    displayName: `PanelTeaser(${displayName})`,
  })
